import '../css/site.scss';
require('../vendor/vex.combined.min.js');
require('../vendor/jquery-ui.min.js');
require('../vendor/object-fit-images.min.js');
require('../vendor/object-fit-videos.min.js');
require('../vendor/lottie.min.js');
require('../../node_modules/jquery-validation/dist/jquery.validate.min.js');
require('../../node_modules/semantic-ui-dropdown/dropdown.js');
require('../../node_modules/semantic-ui-transition/transition.js');
import './add-contact-dialog';
import './button-loader';
import './calendar.ts';
import './calenderAddEvent.ts';
import './campaigns/get-discount.ts';
import './campaigns/read-more.ts';
import './case-page.ts';
import './communication.ts';
import './cookie.ts';
import './dataLayer/data-layer-helper.ts';
import './dataLayer/inspection.ts';
import './dataLayer/maintenance-action.ts';
import './dataLayer/min-tradgard.ts';
import './dataLayer/renovation.ts';
import './demoAccount/hide-functionality.ts';
import './demoAccount/read-more.ts';
import './dialog.ts';
import './email-settings.ts';
import './file-handler.ts';
import './file-upload.ts';
import './finish-case-dialog.ts';
import './form-actions.ts';
import './history.ts';
import './house-details.ts';
import './inspection-action-page.ts';
import './inspection-status-bar.ts';
import './lottie-player';
import './maintenance-action-dialog';
import './maintenance-page';
import './instruction-book';
import './MinTradgard/add-plant.ts';
import './MinTradgard/form-validation.ts';
import './MinTradgard/garden-comments.ts';
import './MinTradgard/garden-form-util.ts';
import './MinTradgard/garden-map.ts';
import './MinTradgard/garden-plot.ts';
import './MinTradgard/garden-popup.ts';
import './MinTradgard/garden-spot-image-upload.ts';
import './MinTradgard/map-image-upload.ts';
import './MinTradgard/map-tutorial.ts';
import './onboarding-3d-model';
import './onboarding-demo-account';
import './onboarding-test-account';
import './popup';
import './renovations/renovation-edit.ts';
import './renovations/renovation-toggle.ts';
import './selected-house';
import './site.ts';
import './sortable';
import './startpage';
import './status-bar';
import './step-area';
import './test-account-dialog';
import './testAccount/read-more.ts';
import './userProgress';
